<h2 mat-dialog-title>
    <mat-icon class="icon-20">merge_type</mat-icon> Merge {{type}}
</h2>
<section *ngIf="loading">
    <h2>Loading...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading...">
    </mat-progress-bar>
</section>
<mat-card *ngIf="!loading">
    <div>
        <p color="primary">
            <strong>Note:</strong> This feature will merge all the unselected items into the selected
            item below and <strong>DELETE</strong> the unselected items.
        </p>
        <br />
        <label>Select the {{type}} to keep below: <br /></label>
        <small>This item will absorb all data from the remaining items not selected.</small>
        <br />
        <br />
        <!-- Household/Housing Units -->
        <form>
            <table mat-table [dataSource]="items" class="mat-elevation-z8" style="overflow-x: auto;"
                aria-describedby="householdTable">
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef scope="col">&nbsp;</th>
                    <td mat-cell *matCellDef="let element"> <input type="radio" id="id" name="id" value="{{element.id}}"
                            (click)="onChangeSelectedId(element.id)" />
                    </td>
                </ng-container>
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef scope="col">OHA <br /> {{type}} Id</th>
                    <td mat-cell *matCellDef="let element">{{element.id}}</td>
                </ng-container>
                <ng-container matColumnDef="contactName">
                    <th mat-header-cell *matHeaderCellDef scope="col">Contact Name</th>
                    <td mat-cell *matCellDef="let element">{{element.contactName}}</td>
                </ng-container>
                <ng-container matColumnDef="address1">
                    <th mat-header-cell *matHeaderCellDef scope="col">Address</th>
                    <td mat-cell *matCellDef="let element">{{element.address1}}</td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef scope="col">City</th>
                    <td mat-cell *matCellDef="let element">{{element.city}}</td>
                </ng-container>
                <ng-container matColumnDef="zip">
                    <th mat-header-cell *matHeaderCellDef scope="col">Zip</th>
                    <td mat-cell *matCellDef="let element">{{element.zip}}</td>
                </ng-container>
                <ng-container matColumnDef="county">
                    <th mat-header-cell *matHeaderCellDef scope="col">County</th>
                    <td mat-cell *matCellDef="let element">{{element.county}}</td>
                </ng-container>
                <ng-container matColumnDef="waterTreamentProvided">
                    <th mat-header-cell *matHeaderCellDef scope="col">Water <br /> Treament <br /> Provided</th>
                    <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.waterTreamentProvided">Yes</span>
                        <span *ngIf="!element.waterTreamentProvided">No</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="bottledWaterProvided">
                    <th mat-header-cell *matHeaderCellDef scope="col">Bottled <br /> Water <br /> Provided</th>
                    <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.bottledWaterProvided">Yes</span>
                        <span *ngIf="!element.bottledWaterProvided">No</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="personsInHousehold">
                    <th mat-header-cell *matHeaderCellDef scope="col">Persons In <br /> Household</th>
                    <td mat-cell *matCellDef="let element">{{element.personsInHousehold}}</td>
                </ng-container>
                <ng-container matColumnDef="comments">
                    <th mat-header-cell *matHeaderCellDef scope="col">Comments</th>
                    <td mat-cell *matCellDef="let element">{{element.comments}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </form>
    </div>

    <!-- Buttons -->
    <div>
        <br />
        <section *ngIf="merging">
            <h2>Merging...</h2>
            <mat-progress-bar mode="indeterminate" color="warn" aria-label="Merging...">
            </mat-progress-bar>
        </section>
        <button mat-button [disabled]="loading || merging || selectedId <= 0" mat-raised-button color="primary"
            (click)="merge()" title="Merge ">Merge </button>
        &nbsp;
        <button mat-button mat-raised-button mat-dialog-close="Cancel" aria-label="Cancel" [disabled]='merging' Merge
            Households="Cancel">Cancel</button>
    </div>
</mat-card>